@switch (stage()) {
@case ('intake') {
<div class="h-full w-full flex flex-col justify-start items-center overflow-y-auto">
  <div class="mx-auto max-w-7xl px-6 py-14">
    <p class="mb-5 inline-flex items-center gap-2 rounded-full bg-brand-studio/10 px-3.5 py-1.5 text-xs font-bold text-brand-studio-dark dark:text-brand-studio">
      Powered by SHOUT AI
    </p>
    <h2 class="font-heading text-4xl font-bold leading-none tracking-tight sm:text-5xl">What are we<br /><span
        class="text-brand-studio">watching for?</span></h2>
    <p class="mt-4 max-w-3xl text-base text-muted-foreground">Describe the posts you want to catch in a sentence or two.
      SHOUT AI drafts the brief — you review and refine before monitoring starts.</p>

    <div class="mt-9">
      <p class="mb-2.5 text-xs font-bold uppercase tracking-wider text-muted-foreground">Which kind of watch?</p>
      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        @for (type of service.monitoringTypeOptions; track type.type) {
        <button type="button" (click)="selectType(type.type)"
          class="rounded-xl border p-4 text-left"
          [class]="service.monitorType() === type.type ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card'">
          <p class="text-sm font-semibold text-foreground">{{ type.name }}</p>
          <p class="mt-1 text-xs text-muted-foreground">{{ type.description }}</p>
        </button>
        }
      </div>
    </div>

    <div class="mt-8">
      <p class="mb-2.5 text-xs font-bold uppercase tracking-wider text-muted-foreground">Which product?</p>
      @if (products().length) {
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
        @for (product of products(); track product.id) {
        <button type="button" (click)="service.selectedProduct.set(product)"
          class="flex items-center gap-3 rounded-lg border px-3 py-2 text-left"
          [class]="service.selectedProduct()?.id === product.id ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/20' : 'border-border bg-card'">
          <img [src]="imageService.getImageSource(product.productImage, 'gallery')" alt=""
            class="size-10 rounded-sm object-cover" />
          <span class="min-w-0">
            <span class="block truncate text-sm font-medium text-foreground">{{ product.productName }}</span>
            <span class="block truncate text-sm text-muted-foreground">{{ product.productCategory }}</span>
          </span>
        </button>
        }
      </div>
      } @else {
      <p class="text-sm text-muted-foreground">No saved products found — you can add one in the review step.</p>
      }
    </div>

    <div class="mt-8">
      <p class="text-xs font-bold uppercase tracking-wider text-muted-foreground">Describe what to watch for</p>
      <div
        class="mt-2.5 overflow-hidden rounded-xl border border-border bg-card shadow-md focus-within:border-brand-studio focus-within:ring-4 focus-within:ring-brand-studio/20">
        <textarea [value]="prompt()" (input)="prompt.set($any($event.target).value)"
          data-guide-id="monitoring.aiPrompt"
          placeholder="e.g. Watch for new posts that show the product in use, and flag any competitor logos…"
          class="min-h-24 w-full resize-none border-none bg-transparent px-6 pb-2 pt-5 text-lg outline-none placeholder:text-muted-foreground"></textarea>
        <div class="flex items-center justify-end gap-3 px-4 pb-3.5 pt-2">
          <button type="button" class="btn-shout btn-shout-sm btn-shout-primary shrink-0" data-guide-id="monitoring.draft"
            (click)="generate()">
            Draft my brief
          </button>
        </div>
      </div>
    </div>

    <div class="mt-6">
      <p class="mb-3 text-center text-xs font-medium text-secondary">Try an example</p>
      <div class="flex flex-wrap items-center justify-center gap-2">
        @for (example of examples; track example.name) {
        <button type="button" (click)="prompt.set(example.prompt)"
          class="inline-flex items-center rounded-full bg-primary/10 px-3 py-1.5 text-xs font-medium text-accent ring-1 ring-inset ring-primary/15">
          {{ example.name }} — {{ example.description }}
        </button>
        }
      </div>
    </div>
  </div>
</div>
}

@case ('generating') {
<bb-ai-drafting-loader heading="SHOUT AI is drafting your monitoring brief…"
  [thoughts]="monitoringAi.streamingThoughts()" [isCompiling]="monitoringAi.isCompilingBrief()"
  [statusPhrases]="phrases" />
}

@case ('review') {
<div class="h-full w-full flex flex-col justify-start items-center overflow-hidden">
  <div class="w-full h-full grid grid-cols-4 gap-2">
    <div class="col-span-3 h-full overflow-hidden flex flex-col">
      <div class="h-full overflow-y-auto">
        <div class="mx-auto max-w-7xl px-6 sm:px-12">
          <div class="mb-5 rounded-xl bg-gradient-to-br from-brand-studio-dark to-brand-studio px-5 py-4 text-white">
            <p class="font-heading text-lg font-bold leading-none">SHOUT AI has drafted your monitoring brief</p>
            <p class="mt-1 text-sm opacity-85">Everything below is a starting point. Nothing is monitored until you launch.</p>
          </div>

          @for (section of reviewSections; track section.id) {
          <section class="mb-4 rounded-xl border border-border p-6 shadow-md">
            <div class="mb-4 flex items-center gap-2.5">
              <h3 class="font-heading text-xl font-bold">{{ section.title }}</h3>
              @if (section.id === 'requirements') {
              <button type="button" [disabled]="aiBusy()" (click)="regenerate()"
                class="btn-shout btn-shout-xs btn-shout-secondary ml-auto shrink-0">
                {{ aiBusy() ? 'Regenerating…' : 'Regenerate' }}
              </button>
              }
            </div>
            @switch (section.id) {
            @case ('brief') { <cmb-monitoring-define /> }
            @case ('product') { <cmb-product-select /> }
            @case ('requirements') { <cmb-monitoring-requirements /> }
            @case ('window') { <cmb-monitoring-window /> }
            @case ('creators') { <cmb-monitoring-creators /> }
            }
          </section>
          }
        </div>
      </div>
    </div>

    <div class="col-span-1 h-full rounded-xl border border-gray-200 dark:border-white/10">
      <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
        <div class="px-2 py-4 drawer-header-primary overflow-hidden rounded-t-xl">
          <div class="min-w-0 flex-1 px-2">
            <p class="text-md font-semibold text-primary">Monitoring brief drafted</p>
            <p class="text-sm text-secondary">Review the draft, choose your creators, and launch.</p>
          </div>
        </div>
        <div class="flex-1 overflow-y-auto p-4">
          <ul class="flex flex-col gap-3 text-sm">
            <li class="flex items-center gap-2.5">
              <span class="size-2 shrink-0 rounded-full"
                [class]="service.basicInfoModel().briefTitle ? 'bg-brand-studio' : 'bg-border'"></span>
              <p class="m-0 truncate text-secondary">{{ service.basicInfoModel().briefTitle || 'Untitled brief' }}</p>
            </li>
            <li class="flex items-center gap-2.5">
              <span class="size-2 shrink-0 rounded-full"
                [class]="service.selectedProduct() ? 'bg-brand-studio' : 'bg-border'"></span>
              <p class="m-0 truncate text-secondary">{{ service.selectedProduct()?.productName || 'No product selected' }}</p>
            </li>
            <li class="flex items-center gap-2.5">
              <span class="size-2 shrink-0 rounded-full"
                [class]="service.briefTextHtml() ? 'bg-brand-studio' : 'bg-border'"></span>
              <p class="m-0 truncate text-secondary">Brief overview</p>
            </li>
          </ul>
        </div>
        <div class="flex flex-row items-center justify-between gap-2 px-2 py-2">
          <button (click)="onStartOver()" type="button" class="btn-shout btn-shout-xs btn-shout-tertiary shrink-0">
            Start over
          </button>
          <button (click)="launch.emit()" type="button" class="btn-shout btn-shout-sm btn-shout-primary shrink-0">
            Launch brief
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
}
